import React from 'react'
import imagenBanner2 from '../img/bannerAngels.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faArrowUpWideShort, faEye, faUsers, faBurst } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'

const HomeZone = ({ setUserSession, setViewAdminZone, userSession }) => {

    const navigate = useNavigate();

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
        navigate('/adminZone', { replace: true })
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const validacionGestionUser = () => {
        if (userSession.role === 'USUARIO_ADMIN' || userSession.role === 'USUARIO_ROOT') {
            return (
                <div className='div-targer-admin' onClick={() => actionNavigate('GESTION_USUARIOS')}>
                    <FontAwesomeIcon className='icon-menu-principal' icon={faUsers} />
                    <div className='div-targer-action'>
                        Gestionar Usuarios App
                    </div>
                </div>
            )
        } else {
            return (
                <></>
            )
        }
    }

    return (
        <div className='div-container'>
            <div className="row m-0">
                <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                    <div className='div-name-user'>
                        <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                    <div className='div-close-info' style={{ height: "3rem" }}>
                        <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                    </div>
                </div>
            </div>
            <div className='div-banner-imagen-angels-padre' >
                <div className='div-banner-imagen-angels-hijo-admin'>
                    <img src={imagenBanner2} alt='Banner-Scorts' className='img-banner-principal'></img>
                </div>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 div-targer-admin-padre" >
                    <div className='div-targer-admin' onClick={() => actionNavigate('REGISTRA')}>
                        <FontAwesomeIcon className='icon-menu-principal' icon={faArrowUpWideShort} />
                        <div className='div-targer-action'>
                            Cargar scort
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 div-targer-admin-padre" >
                    <div className='div-targer-admin' onClick={() => actionNavigate('VISTA_PRELIMINAR')}>
                        <FontAwesomeIcon className='icon-menu-principal' icon={faEye} />
                        <div className='div-targer-action'>
                            Vista preliminar
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 div-targer-admin-padre" >
                    <div className='div-targer-admin' onClick={() => actionNavigate('RESUMEN')}>
                        <FontAwesomeIcon className='icon-menu-principal' icon={faFile} />
                        <div className='div-targer-action'>
                            Resumen
                        </div>
                    </div>
                </div>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-4 col-md-4 col-lg-2 div-targer-admin-padre" ></div>
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 div-targer-admin-padre" >
                    {
                        validacionGestionUser()
                    }
                </div>
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 div-targer-admin-padre" >
                    <div className='div-targer-admin' onClick={() => actionNavigate('GESTION_CAMPANAS')}>
                        <FontAwesomeIcon className='icon-menu-principal' icon={faBurst} />
                        <div className='div-targer-action'>
                            Campañas
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 col-lg-2 div-targer-admin-padre" ></div>
            </div>
        </div>
    )
}

export default HomeZone